import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ComplaintsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/complaints", { params: toSnakeCase(params) });
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/complaints/${id}`, { params });
  }

  update(id, data) {
    return securedAxiosInstance.put(`/complaints/${id}`, toSnakeCase(data));
  }

  create(data) {
    return securedAxiosInstance.post("/complaints", toSnakeCase(data));
  }
}

export default new ComplaintsService();
